module.exports = __webpack_public_path__ + "img/k_zj1.914939d4.png";